import React, { useMemo } from 'react';
import {
	Typography,
	FormControlLabel,
	Radio,
	RadioGroup,
	FormGroup,
	FormControl,
	FormLabel,
} from '@mui/material';
import {
	CLIENT_TYPE,
	DOMESTIC,
	COMMERCIAL,
} from '@/components/forms/CreateNewBusinessForm/validationSchema';
import { useUpdateDealRowMutation } from '@/features/deals/dealsApi';
import { useParams } from 'react-router-dom';
import { useObjectContext } from '@/hooks/useObjectContext';
import FolioRadioGroup from '@/components/FolioRadioGroup';

export const ClientType = () => {
	const { dealId } = useParams();
	const { dealRow } = useObjectContext();

	const clientType = useMemo(() => dealRow?.[CLIENT_TYPE] ?? '', [dealRow]);

	const [updateDeal] = useUpdateDealRowMutation();

	const onChange = async (event) => {
		const newValue = event.target.value;
		try {
			await updateDeal({
				dealId,
				docId: dealRow?.id,
				properties: {
					[CLIENT_TYPE]: newValue,
				},
			}).unwrap();
		} catch (error) {
			console.error('Error updating client type:', error);
		}
	};

	return (
		<FormControl fullWidth>
			<FormLabel>Risk type</FormLabel>
			<FolioRadioGroup
				name={CLIENT_TYPE}
				value={clientType}
				onChange={onChange}
				disabled={!dealRow}
				items={[
					{ value: COMMERCIAL, label: 'Commercial' },
					{ value: DOMESTIC, label: 'Domestic' },
				]}
			/>
		</FormControl>
	);
};
